import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex min-h-full items-center justify-center p-4" }
const _hoisted_2 = { class: "relative border border-gray-200 dark:border-gray-700 bg-white dark:bg-black rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto" }
const _hoisted_3 = { class: "sticky top-0 bg-white dark:bg-black border-b border-gray-200 dark:border-gray-700 px-6 py-4 flex items-center justify-between z-10" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = { class: "flex-shrink-0 w-10 h-10 rounded-full bg-amber-100 dark:bg-amber-900/20 flex items-center justify-center mr-3" }
const _hoisted_6 = { class: "text-sm text-gray-500 dark:text-gray-400" }
const _hoisted_7 = { class: "mb-6" }
const _hoisted_8 = {
  key: 0,
  class: "mt-2 text-sm text-blue-600 dark:text-blue-400"
}
const _hoisted_9 = {
  key: 0,
  class: "mb-4 p-3 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg"
}
const _hoisted_10 = { class: "text-sm text-red-600 dark:text-red-400" }
const _hoisted_11 = { class: "sticky bottom-0 bg-white dark:bg-black border-t border-gray-200 dark:border-gray-700 pt-4 flex items-center justify-end space-x-3" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  key: 0,
  class: "animate-spin h-4 w-4 text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

import { ref, watch } from 'vue';
import type { Claim, ClaimUpdateData } from '@/types/claim';
import EditIcon from '@/components/icons/EditIcon.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ClaimEditModal',
  props: {
    isOpen: { type: Boolean },
    claim: {},
    loading: { type: Boolean },
    error: {}
  },
  emits: ["close", "submit"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const formData = ref<ClaimUpdateData>({
  claim_status: 'under review',
  rejection_reason: ''
});

// Watch for claim changes to populate form
watch(() => props.claim, (newClaim) => {
  if (newClaim) {
    formData.value = {
      claim_status: newClaim.claim_status,
      rejection_reason: newClaim.rejection_reason || ''
    };
  }
}, { immediate: true });

function handleSubmit() {
  emit('submit', formData.value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "modal" }, {
      default: _withCtx(() => [
        (_ctx.isOpen && _ctx.claim)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "fixed inset-0 z-50 overflow-y-auto",
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["self"]))
            }, [
              _cache[11] || (_cache[11] = _createElementVNode("div", { class: "fixed inset-0 bg-black bg-opacity-50 transition-opacity" }, null, -1)),
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(EditIcon, { classes: "h-5 w-5 text-amber-600 dark:text-amber-400" })
                      ]),
                      _createElementVNode("div", null, [
                        _cache[4] || (_cache[4] = _createElementVNode("h3", { class: "text-xl font-semibold text-gray-900 dark:text-white" }, " Edit Claim ", -1)),
                        _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.claim.claim_number), 1)
                      ])
                    ]),
                    _createElementVNode("button", {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
                      class: "text-gray-400 hover:text-gray-500 dark:hover:text-gray-300 transition-colors duration-200"
                    }, _cache[5] || (_cache[5] = [
                      _createElementVNode("svg", {
                        class: "h-6 w-6",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M6 18L18 6M6 6l12 12"
                        })
                      ], -1)
                    ]))
                  ]),
                  _createElementVNode("form", {
                    onSubmit: _withModifiers(handleSubmit, ["prevent"]),
                    class: "px-6 py-4"
                  }, [
                    _createElementVNode("div", _hoisted_7, [
                      _cache[9] || (_cache[9] = _createElementVNode("h4", { class: "text-lg font-semibold text-gray-900 dark:text-white mb-4" }, "Claim Status", -1)),
                      _createElementVNode("div", null, [
                        _cache[7] || (_cache[7] = _createElementVNode("label", {
                          for: "claim_status",
                          class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
                        }, [
                          _createTextVNode(" Status "),
                          _createElementVNode("span", { class: "text-red-500" }, "*")
                        ], -1)),
                        _withDirectives(_createElementVNode("select", {
                          id: "claim_status",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.claim_status) = $event)),
                          required: "",
                          class: "w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 dark:focus:ring-blue-400 focus:border-transparent bg-white dark:bg-black text-gray-900 dark:text-white"
                        }, _cache[6] || (_cache[6] = [
                          _createElementVNode("option", { value: "under review" }, "Under Review", -1),
                          _createElementVNode("option", { value: "approved" }, "Approved", -1),
                          _createElementVNode("option", { value: "rejected" }, "Rejected", -1),
                          _createElementVNode("option", { value: "ready for pick-up" }, "Ready for Pick-up", -1),
                          _createElementVNode("option", { value: "fulfilled" }, "Fulfilled", -1)
                        ]), 512), [
                          [_vModelSelect, formData.value.claim_status]
                        ])
                      ]),
                      (formData.value.claim_status === 'approved' || formData.value.claim_status === 'rejected')
                        ? (_openBlock(), _createElementBlock("p", _hoisted_8, _cache[8] || (_cache[8] = [
                            _createElementVNode("svg", {
                              xmlns: "http://www.w3.org/2000/svg",
                              class: "h-4 w-4 inline mr-1",
                              fill: "none",
                              viewBox: "0 0 24 24",
                              stroke: "currentColor"
                            }, [
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                              })
                            ], -1),
                            _createTextVNode(" A confirmation modal will be shown when you click Update Claim. ")
                          ])))
                        : _createCommentVNode("", true)
                    ]),
                    (_ctx.error)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.error), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close'))),
                        disabled: _ctx.loading,
                        class: "px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors duration-200 font-medium disabled:opacity-50 disabled:cursor-not-allowed"
                      }, " Cancel ", 8, _hoisted_12),
                      _createElementVNode("button", {
                        type: "submit",
                        disabled: _ctx.loading,
                        class: "px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors duration-200 font-medium disabled:opacity-50 disabled:cursor-not-allowed flex items-center space-x-2"
                      }, [
                        (_ctx.loading)
                          ? (_openBlock(), _createElementBlock("svg", _hoisted_14, _cache[10] || (_cache[10] = [
                              _createElementVNode("circle", {
                                class: "opacity-25",
                                cx: "12",
                                cy: "12",
                                r: "10",
                                stroke: "currentColor",
                                "stroke-width": "4"
                              }, null, -1),
                              _createElementVNode("path", {
                                class: "opacity-75",
                                fill: "currentColor",
                                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                              }, null, -1)
                            ])))
                          : _createCommentVNode("", true),
                        _createElementVNode("span", null, _toDisplayString(_ctx.loading ? 'Updating...' : 'Update Claim'), 1)
                      ], 8, _hoisted_13)
                    ])
                  ], 32)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})